import React from 'react';
import { Stack } from '@atlaskit/primitives';
import { FormattedMessage } from '@atlassian/jira-intl';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
import { TransitionHomeHeader } from '../../../common/ui/transition-home/header';
import { messages as stepMessages } from '../../../common/ui/transition-home/step/messages';
import { UsersAndRolesStepPrimaryAdmin } from './primary-admin';
import { UsersAndRolesStepSiteAdmin } from './site-admin';

export const UsersAndRolesStep = () => {
	const isSiteAdmin = useIsSiteAdmin();
	const isPrimaryAdmin = useIsAdmin();

	if (!isSiteAdmin && !isPrimaryAdmin) {
		throw new Error('UsersAndRolesStep should be rendered only for primary or site admin');
	}

	return (
		<Stack space="space.250">
			<TransitionHomeHeader
				title={<FormattedMessage {...stepMessages.usersAndRolesTitleNonFinal} />}
				description={<FormattedMessage {...stepMessages.usersAndRolesDescriptionNonFinal} />}
			/>

			{isSiteAdmin ? <UsersAndRolesStepSiteAdmin /> : <UsersAndRolesStepPrimaryAdmin />}
		</Stack>
	);
};
